<script setup lang="ts">
import VueQrcode from "@chenfengyuan/vue-qrcode";

interface IOptions {
  width: number,
  height: number,
  errorCorrectionLevel?: string,
  margin?: number,
}

defineProps<{ link: string, options: IOptions }>();
</script>

<template>
  <div v-if="link" class="qrcode-wrapper">
    <VueQrcode
      :value="link"
      :options="options"
    />
    <img
      class="qrcode-logo"
      src="/sx/logo-circle-sx.svg"
      alt="qr_center_logo"
      loading="lazy"
      draggable="false"
    >
  </div>
</template>

<style scoped lang="scss">
.qrcode-wrapper {
  position: relative;
  width: 164px;
  height: 164px;
  padding: 16px;
  display: flex;
  border-radius: 16px;
  border: var(--border-sx-main);
  background: white;
  box-shadow: 0 4px 16px 0 #0000001A;
}

.qrcode-logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 0 0 3px white;
  user-select: none;
  pointer-events: none;
}
</style>